<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Study</label> 
                <select class="form-control" [(ngModel)]="item['study_id']" *ngIf="studies">
                    <ng-container *ngFor="let study of studies">
                        <option [value]="study['id']">
                            {{study['name']}}
                        </option>
                    </ng-container>
                </select> 
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">Prefix</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['study_level_prefix']}"
                    type="text" 
                    [(ngModel)]="item['study_level_prefix']" 
                    class="form-control" 
                    placeholder="">
            </div>
            <div class="col-6">
                <label class="form-label">Naam</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['name']}"
                    type="text" 
                    [(ngModel)]="item['name']" 
                    class="form-control" 
                    placeholder="">
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">SLO ID</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['slo_id']}"
                    type="text" 
                    [(ngModel)]="item['slo_id']" 
                    class="form-control" 
                    placeholder="">
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Omschrijving</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['description']}"
                    type="text" 
                    [(ngModel)]="item['description']" 
                    class="form-control" 
                    placeholder="">
            </div>
        </div>

        <div class="form-buttons">
		    <button type="button" class="btn btn-primary" (click)="save()">
                <span *ngIf="item['id']">Toevoegen</span>
                <span *ngIf="!item['id']">Opslaan</span>
            </button>
        </div>
    </div>
</div>